import { render, staticRenderFns } from "./ReuseAdCard.vue?vue&type=template&id=951b67f0&scoped=true&"
import script from "./ReuseAdCard.vue?vue&type=script&lang=js&"
export * from "./ReuseAdCard.vue?vue&type=script&lang=js&"
import style0 from "./ReuseAdCard.vue?vue&type=style&index=0&id=951b67f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "951b67f0",
  null
  
)

export default component.exports